import { render, staticRenderFns } from "./ModalContent.vue?vue&type=template&id=b4f39d82"
import script from "./ModalContent.vue?vue&type=script&lang=js"
export * from "./ModalContent.vue?vue&type=script&lang=js"
import style0 from "./ModalContent.vue?vue&type=style&index=0&id=b4f39d82&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports